import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class BranchesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/branches/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getConfiguration(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/configuration' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateConfiguration(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/configuration' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdateProduct(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/product' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateProduct(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/product' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// แท็บ delivery platform ของสาขา — เปิด/ปิดรับ + override GP + external_store_id
	async getDeliveryPlatforms(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/delivery-platform' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateDeliveryPlatforms(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/delivery-platform' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/branches/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// ทะเบียนเครื่อง POS ของสาขา (api/docs/vat-compliance.md D10)
	async getPosDevices(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/pos-device' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async createPosDevice(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/branches/' + id + '/pos-device' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updatePosDevice(id, deviceId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/pos-device/' + deviceId + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async deletePosDevice(id, deviceId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/branches/' + id + '/pos-device/' + deviceId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async claimPosDevice(id, deviceId) {
		try {
			const response = await axios.post(BASE_URI + '/v1/branches/' + id + '/pos-device/' + deviceId + '/claim' + signature(), {}, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async releasePosDevice(id, deviceId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/branches/' + id + '/pos-device/' + deviceId + '/claim' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getPaymentMethods(id, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/payment-method' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async createPaymentMethod(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/branches/' + id + '/payment-method' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdatePaymentMethod(id, methodId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/branches/' + id + '/payment-method/' + methodId + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updatePaymentMethod(id, methodId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/branches/' + id + '/payment-method/' + methodId + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async togglePaymentMethodActive(id, methodId, isActive) {
		try {
			const response = await axios.patch(
				BASE_URI + '/v1/branches/' + id + '/payment-method/' + methodId + '/toggle-active' + signature(),
				{ is_active: isActive === true },
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async deletePaymentMethod(id, methodId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/branches/' + id + '/payment-method/' + methodId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Branches = new BranchesApi();
